import apiClient from './client';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
}

export const authApi = {
  login: (credentials: LoginCredentials) => {
    return apiClient.post('/auth/login', credentials);
  },

  register: (data: RegisterData) => {
    return apiClient.post('/auth/register', data);
  },

  logout: () => {
    return apiClient.post('/auth/logout');
  },

  refreshToken: (refreshToken: string) => {
    return apiClient.post('/auth/refresh', { refreshToken });
  },

  forgotPassword: (email: string) => {
    return apiClient.post('/auth/forgot-password', { email });
  },

  resetPassword: (token: string, password: string) => {
    return apiClient.post('/auth/reset-password', { token, password });
  },

  verifyEmail: (token: string) => {
    return apiClient.post('/auth/verify-email', { token });
  },
};
